import {Component, Inject, OnInit} from '@angular/core';
import { constants } from "src/app/shared/common/contants";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
/*
   @Author:Ravi G
   @Date:28-06-2022
*/
export interface FormData {
  dynamicData: any;
  usersObject: any;
}
@Component({
    selector: 'app-permissionspopup',
    templateUrl: './permissionspopup.component.html',
    styleUrls: ['./permissionspopup.component.scss'],
    standalone: false
})
export class PermissionspopupComponent implements OnInit {

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  pageSize;

  overlayNoRowsTemplate;

  columnDefs;

  dynamicData = [];

  usersObject = [];

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  backgroundColorButton = "";

  rowClassRules;

  fieldsData;

  backgroundColorScreen = "";

  value;

  constructor(private constants: constants, private dialogref: MatDialogRef<PermissionspopupComponent>, @Inject(MAT_DIALOG_DATA) public data: FormData, private localStorageSettings: LocalStorageSettingsService) {

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;

    this.dynamicData = this.data.dynamicData;

    this.usersObject = this.data.usersObject;

    console.log(this.dynamicData);

    console.log(this.usersObject);

  }

  ngOnInit() {

    this.columnDefs = [];

    this.columnDefs.push({
      headerName: "Select",
      headerTooltip: "Select",
      tooltipValueGetter: params => "Fields : " + params.value,
      field: "selectedField",
      filter: "agTextColumnFilter",
      width: 160,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      cellStyle: { " padding-left": "5px" }
    });

    // this.columnDefs.push({
    //   headerName: 'Status',
    //   headerTooltip: 'Status',
    //   tooltipValueGetter: (params) => 'Status : ' + params.value,
    //   field: 'status',
    //   filter: 'agTextColumnFilter',
    //   width: 150,
    //   cellStyle: function (params) {
    //     if (params.value == 'Yes') {
    //       return { color: 'green' };
    //     } else {
    //       return { color: 'red' };
    //     }
    //   }
    // });

    console.log("this.dynamicData");

    console.log(this.dynamicData);

    this.dynamicData.forEach(e => {

      console.log("e");

      console.log(e);

      if (e.showinGrid) {

        let fieldName = "";

        console.log(e.fieldType);

        console.log(e.fieldType == "valueDropDown");

        //if columntype is valueparentdropdown or valuedropdown then dropdownvalues are storing into columnname
        if (e.fieldType == "valueParentDropDown" || e.fieldType == "valueDropDown") {

          fieldName = e.dropDownValues;

          console.log(fieldName);

        }
        else if (e.fieldType == "Linked Fields" || e.fieldType == "Select List - Static") {

          fieldName = e.fieldName.toString() + 1;

          console.log(fieldName);

        }

        else {

          fieldName = e.fieldName;

          console.log(fieldName);

        }

        console.log("fieldName");

        console.log(fieldName);

        this.columnDefs.push({
          headerName: e.agGridColumnName,
          headerTooltip: e.agGridColumnName,
          tooltipValueGetter: params => e.agGridColumnName + " : " + params.value,
          field: fieldName,
          filter: "agTextColumnFilter",
          width: 180
        });

      }

    });

    console.log(this.columnDefs);

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;

    this.paginationPageSize = this.constants.pagesize;

    this.paginationNumberFormatter = function (params) {

      return params.value.toLocaleString();

    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridAPI.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {

    console.log("onGridReady(params)");

    console.log("this.usersObject");

    console.log(this.usersObject);

    this.gridAPI = params.api;

    this.gridColumnAPI = params.columnApi;

    this.gridAPI.setGridOption('rowData', this.usersObject);

  }

  onRowSelected(event) {

    this.fieldsData = this.gridAPI.getSelectedRows();

    console.log(this.fieldsData);

  }

  close() {

    this.dialogref.close(this.fieldsData);

  }

}
